export default __webpack_public_path__ + "d9277fa0cdb76e9bace7bbfd4186c3db.png";